export function formatCellErrorMessage(msg: string): string {
	//
	// Remove artifacts of the emitted code.
	//
	// Moment cells are essentially function bodies, in that you can `yield`, `return`, etc. A naked
	// function body is not technically valid JavaScript though, so the compiler wraps the cell code
	// in a function so that it can be called by the runtime.
	//
	// Normally this function is completely invisible to the canvas author. Error messages are one
	// place it "leaks out" accidentally. When the parser reports a syntax error, it will sometimes
	// accidentally include the function in the error message.
	//
	// This code removes that function, which is called `SHOULD_BE_ERASED`. It will not make sense
	// to users.
	//
	// See more details here: app/src/utils/function-body-cell/index.ts
	//

	if (msg === undefined) {
		return "";
	}

	return (
		msg
			// Remove the first line
			.replace(/^(.*)?[\r\n]/m, "")
			// Remove the double extraneous newlines between the error message and surrounding code lines
			.replace(/\n/, "")
			// Always remove the first line if present. It will look something like this:
			//
			//     1 | async function* SHOULD_BE_ERASED() {
			.replace(/ *1 \| .*\n/, "")
	);
}
